import React from 'react';
import { Leaf } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brown text-parchment/60 py-12 px-6 text-center" data-id="element-55">
      <div className="max-w-4xl mx-auto flex flex-col items-center" data-id="element-56">
        <div className="flex items-center text-parchment/80 font-playfair font-bold text-xl mb-6" data-id="element-57">
          <Leaf className="w-5 h-5 mr-2" data-id="element-58" />
          Botica Natural
        </div>

        <p className="text-xs text-parchment/40 max-w-2xl mb-6 leading-relaxed" data-id="element-59">
          Descargo de responsabilidad: Este producto es una guía educativa
          basada en prácticas tradicionales. Los resultados pueden variar de
          persona a persona. Las pomadas naturales no sustituyen la atención
          médica profesional. Consulta a un dermatólogo o profesional de la
          salud si tienes condiciones médicas graves o alergias conocidas.
        </p>

        <p className="text-sm mb-6" data-id="element-60">
          © {new Date().getFullYear()} Pomadas Naturales. Todos los derechos
          reservados.
        </p>

        <div className="flex gap-6 text-sm" data-id="element-61">
          <a href="#" className="hover:text-parchment transition-colors" data-id="element-62">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-parchment transition-colors" data-id="element-63">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-parchment transition-colors" data-id="element-64">
            Contacto
          </a>
        </div>
      </div>
    </footer>;
}